import { render, staticRenderFns } from "./VolunteerApplyAdd.vue?vue&type=template&id=68339bbd&scoped=true"
import script from "./VolunteerApplyAdd.vue?vue&type=script&lang=js"
export * from "./VolunteerApplyAdd.vue?vue&type=script&lang=js"
import style0 from "./VolunteerApplyAdd.vue?vue&type=style&index=0&id=68339bbd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68339bbd",
  null
  
)

export default component.exports